export function toArray(records) {
  return records?.toArray?.() ?? records ?? [];
}

function cptRateBucketKey(bucket) {
  return String(bucket.key ?? '').trim();
}

function bucketDocCount(bucket) {
  return Number(bucket?.docCount ?? bucket?.count ?? 0);
}

function shouldSkipBucket(key, docCount, includeZeroDocCounts) {
  return !key || (!includeZeroDocCounts && docCount < 1);
}

function upsertMaxDocCount(docCountByKey, key, docCount) {
  let previous = docCountByKey.get(key);
  if (!previous || docCount > previous.docCount) {
    docCountByKey.set(key, { key, docCount });
  }
}

export function bucketsFromAggregationWithMatches(buckets, { includeZeroDocCounts = false } = {}) {
  let docCountByKey = new Map();

  for (let raw of buckets ?? []) {
    let key = cptRateBucketKey(raw);
    let docCount = bucketDocCount(raw);

    if (shouldSkipBucket(key, docCount, includeZeroDocCounts)) {
      continue;
    }

    upsertMaxDocCount(docCountByKey, key, docCount);
  }

  let list = [...docCountByKey.values()];
  return { list, docCountByKey };
}

export function validGroups(groups) {
  return groups?.length && groups[0].rates?.length;
}
